<template>
  <div v-if="!isInstall" id="optimize99-ab-test-header" class="optimize99-ab-test-header-container">
    <div class="optimize99-ab-test-header">
      <!-- LOGO -->
      <div class="title">
        <div class="back mr-3" @click="goExperience">
          <span class="opt-icon-container">
            <v-icon color="#FFF">mdi-chevron-left</v-icon>
          </span>
        </div>
        <div class="logo">
          <img
            src="https://shoplineimg.com/61c975947448c5006965ee7c/6461c3ac8212c3000edbd5af/200x.webp?source_format=png"
          />
        </div>
        <div class="experience">
          <div class="opt-experience-name">{{ experience.name }}</div>
          <p class="opt-version-name">{{ view_content.name }}</p>
        </div>
      </div>

      <!-- 選擇器 -->
      <div class="content">
        <v-icon color="#FFFFFF" class="mr-3">
          {{ selected_device_type.icon }}
        </v-icon>
        <v-select
          v-model="selected_device_type"
          class="device_selector"
          :width="260"
          :items="device_types"
          item-text="name"
          item-value="id"
          dense
          outlined
          hide-details
          return-object
          background-color="#FFF"
          @change="selectType"
        >
        </v-select>
      </div>

      <!-- 保存 -->
      <div class="action ml-15" @click="saveConfig">
        <div
          class="btn_action btn_action_bg_linear opt-save-btn reset-bd"
          :class="{
            'btn-hightlight': original_hash !== current_hash,
          }"
        >
          <span>存檔</span>
          <v-icon color="#FFF">mdi-chevron-right</v-icon>
        </div>
      </div>
    </div>

    <v-bottom-navigation
      v-model="ab_test_toolbar_tab"
      class="justify-end"
      height="32px"
      color="primary"
      background-color="#f1f3f4"
    >
      <template v-for="(btn_info, index) in ab_test_toolbar_tab_group">
        <v-tooltip :key="index" bottom>
          <template #activator="{ on, attrs }">
            <v-btn
              v-if="btn_info.is_show"
              v-bind="attrs"
              :value="btn_info.value"
              v-on="on"
              @click="openEditor(btn_info.value)"
            >
              <v-icon v-text="btn_info.icon" />
            </v-btn>
          </template>
          <span class="text-center">{{ btn_info.title }}</span>
        </v-tooltip>
      </template>
    </v-bottom-navigation>

    <v-dialog v-model="change_tool_dialog.status" max-width="600" @click:outside="change_tool_dialog.click_outside()">
      <v-card>
        <v-card-title class="primary white--text" v-text="change_tool_dialog.title" />
        <v-card-text class="pt-5" v-text="change_tool_dialog.content" />
        <v-card-actions class="justify-space-between">
          <v-btn @click="change_tool_dialog.cancel()" v-text="change_tool_dialog.cancel_text" />
          <v-btn color="primary" @click="change_tool_dialog.sure()" v-text="change_tool_dialog.sure_text" />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
import store from '@/store'
import { eventBus } from '@/event_bus.js'
import { mapGetters } from 'vuex'
import { apiPatchView, apiGetViewWithData } from '@/api/optimize.js'
import { apiUploadFile } from '@/api/common.js'
import {
  apiUpdateOnlineUserPlugin,
  apiDeleteOnlineUserPlugin,
  apiUpdateCounterPlugin,
  apiDeleteCounterPlugin,
} from '@/api/urlview.js'

export default {
  name: 'Header',
  props: {
    experience: {
      type: Object,
      default: () => {},
    },
    view: {
      type: Object,
      default: () => {},
    },
    viewData: {
      type: Object,
      default: () => {},
    },
    isInstall: {
      type: Boolean,
      default: false,
    },
    initStepHistorys: {
      type: Array,
      default: () => [],
    },
    initStepHistoryIndex: {
      type: Number,
      default: 0,
    },
    defaultDeviceType: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      view_content: this.view,
      experience_name: '',
      view_name: '',
      device_types: [
        {
          id: 'desktop',
          icon: 'mdi-monitor',
          name: '桌機',
        },
        {
          id: 'tablet',
          icon: 'mdi-tablet',
          name: '平板',
        },
        {
          id: 'mobile',
          icon: 'mdi-cellphone',
          name: '手機',
        },
      ],
      selected_device_type: this.defaultDeviceType,
      step_historys: [],
      step_history_index: -1,
      is_changed: false,
      plugins: {},
      original_plugins: {},
      create_plugins: {},
      update_plugins: {},
      delete_plugins: {},
      change_tool_dialog: {
        status: false,
        title: '',
        content: '',
        cancel_text: '',
        cancel: null,
        sure_text: '',
        sure: null,
        click_outside: null,
      },
      ab_test_toolbar_tab: 'Editor',
      ab_test_toolbar_tab_group: [
        { title: '網頁編輯器', icon: 'mdi-tune', value: 'Editor', is_show: true },
        {
          title: '動畫編輯器',
          icon: 'mdi-animation-play-outline',
          value: 'AnimationEditor',
          is_show: this.$auth_helper.isShowFeature(this.$store, this.$route.params.org_id, 'ExperienceAnimation'),
        },
        {
          title: '圖片排序',
          icon: 'mdi-swap-vertical-bold',
          value: 'elementSort',
          is_show: this.$auth_helper.isShowFeature(this.$store, this.$route.params.org_id, 'ExperienceEleSort'),
        },
        // 因目前只有開放圖片排序所以 title 先叫 "圖片排序"
        {
          title: '輪播',
          icon: 'mdi-view-carousel-outline',
          value: 'Carousel',
          // is_show: true,
          is_show: this.$auth_helper.isShowFeature(this.$store, this.$route.params.org_id, 'ExperienceCarousel'),
        },
        {
          title: '互動模式',
          icon: 'mdi-cursor-default-click-outline',
          value: 'Interactor',
          is_show: true,
        },
      ],
      file_size: 1,
      original_hash: '',
      current_hash: '',
      curr_activate_editor: 'Editor',
    }
  },
  computed: {
    ...mapGetters(['device_type']),
    ...mapGetters('optimize', ['activate_editor', 'is_open_editor']),
  },
  async created() {
    eventBus.$on('update-header-history', this.updateHistory)
    eventBus.$on('update-header-plugin-history', this.updatePluginHistory)
    eventBus.$on('change-editor', this.changeEditTool)
    this.step_historys = this.initStepHistorys
    this.step_history_index = this.initStepHistoryIndex
    this.initPlugin(this.viewData)
    this.openEditor(this.ab_test_toolbar_tab)
    this.original_hash = this.getMD5Hash(this.step_historys)
    this.current_hash = this.original_hash
    console.log('original_hash', this.original_hash)
  },
  destroyed() {
    eventBus.$off('update-header-history', this.updateHistory)
    eventBus.$off('update-header-plugin-history', this.updatePluginHistory)
  },
  mounted() {
    addEventListener('keydown', (e) => {
      if (e.key === 'Alt') {
        store.commit('optimize/SET_EDITOR', 'Interactor')
        this.ab_test_toolbar_tab = 'Interactor'
      }
    })

    addEventListener('keyup', (e) => {
      if (e.key === 'Alt') {
        this.openEditor(this.curr_activate_editor)
      }
    })

    eventBus.$on('iframe_trigger_alt', this.iframeTriggerAlt)
  },
  methods: {
    iframeTriggerAlt(e) {
      if (e === 'keydown') {
        store.commit('optimize/SET_EDITOR', 'Interactor')
        this.ab_test_toolbar_tab = 'Interactor'
      } else if (e === 'keyup') {
        this.openEditor(this.curr_activate_editor)
      }
    },
    async selectType() {
      console.log('selected_device_type', this.selected_device_type)
      this.$store.commit('setDeviceType', this.selected_device_type.id)
      let currentQuery = { ...this.$route.query }
      currentQuery.device_type = this.selected_device_type.id
      await this.saveConfig(true)
      await this.$router.replace({ query: currentQuery })
      this.$router.go()
    },
    changeToolDialog(data) {
      this.change_tool_dialog = {
        status: true,
        title: data.title,
        content: data.content,
        cancel_text: data.cancel_text,
        cancel: data.cancel,
        sure_text: data.sure_text,
        sure: data.sure,
        click_outside: data.click_outside,
      }
    },
    changeEditTool(new_val) {
      this.openEditor(new_val)
    },
    openEditor(tab_value) {
      store.commit('optimize/SET_EDITOR', tab_value)
      console.log('OpenEditor', this.activate_editor)
      if (tab_value === 'Interactor') {
        store.commit('optimize/SET_IS_OPEN_EDITOR', false)
      } else {
        store.commit('optimize/SET_IS_OPEN_EDITOR', true)
      }
      this.ab_test_toolbar_tab = tab_value
      this.curr_activate_editor = tab_value
    },
    async saveConfig(is_silence) {
      // 存檔的話 只存到當前這步的歷史紀錄，
      let step_historys = this.step_historys
      let idx = this.step_history_index
      step_historys.splice(idx + 1, step_historys.length - idx - 1)
      idx = step_historys.length - 1
      this.step_historys = step_historys
      this.step_history_index = idx
      eventBus.$emit('update-editor-history', this.step_historys, this.step_history_index)
      console.log('historys', this.step_historys)
      let new_step_historys = JSON.parse(JSON.stringify(this.step_historys))
      // 把original_info濾掉
      let clear_historys = []
      clear_historys = new_step_historys.map(function (step_history) {
        let tmp_history = {}
        let expected_fields = [
          'nodeName',
          'attribute',
          'selector',
          'ref_selector',
          'type',
          'new_value',
          'method',
          'css',
          'plugin_data',
          'target_selector',
          'param_name',
          'param_type',
          'new_values',
          'need_new_ele',
          'from',
          'to',
        ]
        expected_fields.forEach(function (expected_field) {
          if (expected_field === 'plugin_data' && step_history.plugin_data) {
            let save_fields = ['type', 'id', 'selector']
            console.log('filter_fields', step_history.plugin_data['type'])
            Object.keys(step_history.plugin_data).forEach(function (field_key) {
              if (save_fields.includes(field_key) === false) {
                delete step_history.plugin_data[field_key]
              }
            })
          }
          if (step_history[expected_field]) {
            tmp_history[expected_field] = step_history[expected_field]
          } else {
            tmp_history[expected_field] = ''
          }
          tmp_history['node_name'] = step_history.original_info ? step_history.original_info.nodeName : ''
        })
        return tmp_history
      })

      console.log('clear_historys1:', clear_historys)
      clear_historys = clear_historys.filter(function (clear_history) {
        return clear_history
      })
      console.log('clear_historys2:', clear_historys)
      let map_tag_historys = []
      let sdk_historys = clear_historys.map((clear_history) => {
        let keys = Object.keys(clear_history)
        keys.forEach((key) => {
          if (!clear_history[key]) {
            delete clear_history[key]
          }
        })
        map_tag_historys.push(clear_history.node_name)
        return clear_history
      })

      console.log('sdk_history', sdk_historys)
      const chunkSize = this.file_size * 1024 * 1024 // 轉換為 bytes
      let sdk_history_files = this.$utils.splitObjectArrayBySize(sdk_historys, chunkSize)
      let step_history_files = this.$utils.splitObjectArrayBySize(step_historys, chunkSize)
      console.log('sdk_file_historys', sdk_history_files)
      console.log('step_history_files', step_history_files)
      console.log('map_tag_historys', map_tag_historys)

      this.$root.vprogress.init({
        message: '保存設定中....(1/4)',
      })
      this.$root.vprogress.setValue(25)
      this.$root.vprogress.show()

      let sdk_file_ids = []
      let step_file_ids = []
      let upload_files = []
      for (let idx = 0; idx < sdk_history_files.length; idx++) {
        let data = {
          category: this.$route.params.container_id,
          content: JSON.stringify(sdk_history_files[idx]),
          file_ext: 'json',
          group_id: `vid:${this.view_content.vid}`,
        }
        try {
          let result = await apiUploadFile(data)
          console.log('result', result)
          sdk_file_ids.push(result.url)
          upload_files.push(result.url)
        } catch (error) {
          console.log('upload_error', error)
        }
      }
      for (let idx = 0; idx < step_history_files.length; idx++) {
        let data = {
          category: this.$route.params.container_id,
          content: JSON.stringify(step_history_files[idx]),
          file_ext: 'json',
          group_id: `vid:${this.view_content.vid}`,
        }
        try {
          let result = await apiUploadFile(data)
          console.log('result', result)
          step_file_ids.push(result.url)
          upload_files.push(result.url)
        } catch (error) {
          console.log('upload_error', error)
        }
      }
      this.$root.vprogress.setText('保存設定中....(2/4)')
      this.$root.vprogress.setValue(50)

      // 準備送API的格式
      let add_column = {}
      if (this.view.add_column) {
        add_column = JSON.parse(this.view.add_column)
      }
      add_column['history'] = step_historys

      let param = {}
      let view_param = {
        id: this.view_content.id,
        // 用來存給sdk跑的步驟，改成用檔案
        campaign: {
          pc: JSON.stringify(sdk_file_ids),
          phone: JSON.stringify(sdk_file_ids),
          pad: JSON.stringify(sdk_file_ids),
        },
        // 完整的步驟，改成用檔案
        over: {
          pc: JSON.stringify(step_file_ids),
          phone: JSON.stringify(step_file_ids),
          pad: JSON.stringify(step_file_ids),
        },
        // 用來map tag有沒有不見的紀錄，直接存
        warm_up: {
          pc: JSON.stringify(map_tag_historys),
          phone: JSON.stringify(map_tag_historys),
          pad: JSON.stringify(map_tag_historys),
        },
        experience_id: this.experience.id,
        upload_files: upload_files,
        add_column: JSON.stringify(add_column),
      }
      param['view'] = view_param
      param['plugin'] = {}

      let that = this
      // 每個plugin種類檢查一次這次有變更的
      Object.keys(this.plugins).forEach(function (plugin_name) {
        param[plugin_name] = []
        that.create_plugins[plugin_name] = []
        that.update_plugins[plugin_name] = []
        that.delete_plugins[plugin_name] = []

        // 沒有view_key的通通刪掉
        let empty_id_settings = that.original_plugins[plugin_name].filter(function (p) {
          p.action = 'delete'
          return p.view_key === ''
        })
        console.log('empty_id_settings:', empty_id_settings)
        that.delete_plugins[plugin_name] = that.delete_plugins[plugin_name].concat(empty_id_settings)

        let exist_id_settings = that.original_plugins[plugin_name].filter(function (p) {
          return p.view_key !== ''
        })

        // 頁面的plugins
        console.log('plugin_name:', plugin_name)
        console.log('that.plugins:', that.plugins)
        let plugins = that.plugins[plugin_name]
        plugins.forEach(function (plugin) {
          console.log('plugin.setting', plugin.setting)
          plugin.setting.status = plugin.status
          plugin.setting.id = plugin.id

          let target_idx = exist_id_settings.findIndex((obj) => obj.view_key === plugin.id)
          console.log('target_idx', target_idx)
          if (target_idx !== -1) {
            plugin.setting.id = exist_id_settings[target_idx].id
            if (plugin.setting.status === 'delete') {
              plugin.setting.action = 'delete'
              that.delete_plugins[plugin_name].push(plugin.setting)
            } else if (plugin.setting.status === 'update') {
              plugin.setting.action = 'update'
              that.update_plugins[plugin_name].push(plugin.setting)
            }
          } else {
            plugin.setting.add_col = JSON.stringify({
              view_key: plugin.setting.id,
              selector: plugin.selector,
            })
            delete plugin.setting.id
            plugin.setting.action = 'create'
            that.create_plugins[plugin_name].push(plugin.setting)
          }

          if (that.create_plugins[plugin_name].length > 0) {
            param[plugin_name] = that.handleRequestData(plugin_name, that.create_plugins[plugin_name])
            console.log('param[plugin_name]_1', param[plugin_name])
          }
          if (that.update_plugins[plugin_name].length > 0) {
            param[plugin_name] = param[plugin_name].concat(
              that.handleRequestData(plugin_name, that.update_plugins[plugin_name])
            )
            console.log('param[plugin_name]_2', param[plugin_name])
          }
          if (that.delete_plugins[plugin_name].length > 0) {
            param[plugin_name] = param[plugin_name].concat(
              that.handleRequestData(plugin_name, that.delete_plugins[plugin_name])
            )
            console.log('param[plugin_name]_3', param[plugin_name])
          }
          param['plugin'][plugin_name] = param[plugin_name]
        })
      })
      console.log('original_plugins:', this.original_plugins)
      console.log('delete_plugins:', that.delete_plugins)
      console.log('update_plugins:', that.update_plugins)
      console.log('create_plugins:', that.create_plugins)
      console.log('save_param:', param)
      let dialog_setting = {
        alert_type: {
          is_show: true,
          type: 'info',
          color: 'info',
          icon: 'mdi-information-variant-circle-outline',
        },
        is_show: true,
        title: '系統訊息',
        text: '儲存修改記錄中...',
        btns: [
          {
            text: '關閉',
            callback: this.closeBtn,
            color: 'grey',
          },
          {
            text: '返回版本列表',
            callback: this.goExperience,
            color: 'primary',
          },
        ],
        time: 0,
      }

      let resp = await apiPatchView(param, this.$route.params.org_id)
        .then(function (resp) {
          if (resp.data.ok !== 1) {
            return {
              result: 'fail',
              error: resp.data.msg,
            }
          } else {
            return {
              result: 'success',
              data: resp.data.data,
            }
          }
        })
        .catch(function (error) {
          return {
            result: 'fail',
            error: error.response ? error.response.data : error,
          }
        })
      this.$root.vprogress.setText('保存設定中....(3/4)')
      this.$root.vprogress.setValue(75)

      // 刪除舊檔
      // let file_obj = JSON.parse(this.view_content.file_obj)
      // if (file_obj && file_obj.upload_files) {
      //   let original_files = file_obj.upload_files
      //   if (original_files) {
      //     for (let idx = 0; idx < original_files.length; idx++) {
      //       try {
      //         let result = await apiDeleteFile(this.$route.params.container_id, original_files[idx])
      //         console.log('result', result)
      //       } catch (error) {
      //         console.log('delete-error', error)
      //       }
      //     }
      //   }
      // }
      this.$root.vprogress.setText('保存完成....(4/4)')
      this.$root.vprogress.setValue(100)
      this.$root.vprogress.hide()

      // await this.deletePlugin(this.delete_plugins)
      // await this.updatePlugin(this.update_plugins)

      if (is_silence !== true) {
        if (resp.result === 'success') {
          dialog_setting.alert_type.type = 'success'
          dialog_setting.alert_type.color = 'success'
          dialog_setting.alert_type.icon = 'mdi-check-circle-outline'
          dialog_setting.text = '儲存成功'
          console.log(resp)
        } else {
          dialog_setting.alert_type.icon = 'mdi-alert-circle-outline'
          dialog_setting.alert_type.type = 'error'
          dialog_setting.alert_type.color = 'error'
          dialog_setting.text = resp.error
        }
        eventBus.$emit('open-dialog', dialog_setting)
      }

      // 重新取得一次view的plugin，並且初始化original_plugins
      // 視為和重新進入一樣
      try {
        let result = await apiGetViewWithData(this.viewData.view.id, this.$route.params.org_id)
        console.log('reget_plugin: ', result)
        let data = result.data
        console.log('data', data)
        this.initPlugin(data)
        this.create_plugins = {}
        this.update_plugins = {}
        this.delete_plugins = {}
        window.removeEventListener('beforeunload', this.handleLeave)
        this.original_hash = this.current_hash
        this.view_content.file_obj = data.view.file_obj
      } catch (error) {
        let message = '取得版本資訊失敗，原因: '
        if (error.response) {
          message += error.response.data.msg
        } else {
          message += error
        }
        this.$root.vtoast.show({
          message: message,
        })
      }
    },
    closeBtn() {
      eventBus.$emit('open-dialog', {
        is_show: false,
      })
    },
    goExperience() {
      this.$router.go(-1)
    },
    updateHistory(historys, history_idx) {
      console.log('header更新歷史', historys)
      console.log('header更新歷史', history_idx)
      this.step_historys = historys
      this.step_history_index = history_idx

      let step_historys = JSON.parse(JSON.stringify(this.step_historys))
      let idx = this.step_history_index
      step_historys.splice(idx + 1, step_historys.length - idx - 1)
      this.current_hash = this.getMD5Hash(step_historys)
      console.log('now_hash', this.current_hash)

      if (this.current_hash !== this.original_hash) {
        window.addEventListener('beforeunload', this.handleLeave)
      } else {
        window.removeEventListener('beforeunload', this.handleLeave)
      }
    },
    updatePluginHistory(plugin_data, step) {
      console.log('header-plugin-history', plugin_data)
      console.log('methoddddd:', plugin_data.method)
      let plugin_type = plugin_data.type
      let target = plugin_data
      let target_idx = 0
      if (!this.plugins[plugin_type]) {
        this.plugins[plugin_type] = []
      }

      target_idx = this.plugins[plugin_type].findIndex((obj) => obj.id === target.id)

      switch (plugin_data.method) {
        case 'create':
          if (step === 'next') {
            if (target_idx !== -1) {
              this.plugins[plugin_type][target_idx]['status'] = 'create'
            } else {
              plugin_data.status = 'create'
              this.plugins[plugin_type].push(plugin_data)
            }
          } else {
            if (target_idx !== -1) {
              this.plugins[plugin_type][target_idx]['status'] = 'delete'
            } else {
              plugin_data['status'] = 'delete'
              plugin_data['created_by'] = 'auto'
              this.plugins[plugin_type].push(plugin_data)
            }
          }

          break
        case 'update':
          plugin_data.status = 'update'
          if (target_idx !== -1) {
            this.plugins[plugin_type][target_idx].status = 'update'
            if (step === 'next') {
              this.plugins[plugin_type][target_idx].setting = plugin_data.setting
            } else {
              this.plugins[plugin_type][target_idx].setting = plugin_data.old_setting
            }
          }
          // 找不到的狀況是，一進來讀完舊檔直接改，原本的plugin會是空的
          else {
            plugin_data['created_by'] = 'auto'
            this.plugins[plugin_type].push(plugin_data)
            console.log(`${plugin_type}_${plugin_data.method}_找不到`)
          }
          break
        case 'delete':
          if (target_idx !== -1) {
            if (step === 'next') {
              this.plugins[plugin_type][target_idx]['status'] = 'delete'
            } else {
              this.plugins[plugin_type][target_idx]['status'] = 'update'
            }
          } else {
            plugin_data['status'] = 'delete'
            plugin_data['created_by'] = 'auto'
            this.plugins[plugin_type].push(plugin_data)
            console.log(`${plugin_type}_${plugin_data.method}_找不到`)
          }
          break
        default:
          console.log('unknown_plugin_update_method')
      }

      console.log('after_update_plugins:', this.plugins)
    },
    initPlugin(view_data) {
      let that = this
      // 把每個plugin的設定檔讀進來
      Object.keys(view_data).forEach(function (view_feature) {
        if (view_feature !== 'view') {
          that.original_plugins[view_feature] = JSON.parse(JSON.stringify(view_data[view_feature]))
        }
      })

      // 把前端的key讀出來
      Object.keys(this.original_plugins).forEach(function (plugin_name) {
        that.original_plugins[plugin_name].forEach(function (plugin) {
          plugin['view_key'] = ''
          try {
            let add_column = JSON.parse(plugin.add_column)
            plugin['view_key'] = add_column['view_key']
          } catch (error) {
            console.log('parse_add_column_error', error)
          }
        })
      })
      this.plugins = []
      console.log('init_original_plugin', this.original_plugins)
      console.log('init_plugins', this.plugins)
    },
    async deletePlugin(delete_plugins) {
      let plugin_types = Object.keys(delete_plugins)

      for (let idx = 0; idx < plugin_types.length; idx++) {
        let plugin_type = plugin_types[idx]

        if (!delete_plugins[plugin_type]) {
          continue
        }

        for (let idx2 = 0; idx2 < delete_plugins[plugin_type].length; idx2++) {
          let target_plugin = delete_plugins[plugin_type][idx2]
          let result = ''
          switch (plugin_type) {
            case 'online_user':
              result = await apiDeleteOnlineUserPlugin(this.$route.params.org_id, target_plugin.id)
              console.log('delete_plugin: ', result)
              break
            case 'sales_counter':
              result = await apiDeleteCounterPlugin(this.$route.params.org_id, target_plugin.id)
              console.log('delete_plugin: ', result)
              break
          }
        }
      }
    },
    async updatePlugin(update_plugins) {
      let plugin_types = Object.keys(update_plugins)

      for (let idx = 0; idx < plugin_types.length; idx++) {
        let plugin_type = plugin_types[idx]

        if (!update_plugins[plugin_type]) {
          continue
        }
        update_plugins[plugin_type] = this.handleRequestData(plugin_type, update_plugins[plugin_type])
        for (let idx2 = 0; idx2 < update_plugins[plugin_type].length; idx2++) {
          let target_plugin = update_plugins[plugin_type][idx2]
          let result = ''
          switch (plugin_type) {
            case 'online_user':
              result = await apiUpdateOnlineUserPlugin(this.$route.params.org_id, target_plugin)
              console.log('update_plugin: ', result)
              break
            case 'sales_counter':
              result = await apiUpdateCounterPlugin(this.$route.params.org_id, target_plugin)
              console.log('update_plugin: ', result)
              break
          }
        }
      }
    },
    handleRequestData(plugin_type, plugins) {
      let tmp_plugins = JSON.parse(JSON.stringify(plugins))
      tmp_plugins.forEach(function (tmp_plugin) {
        switch (plugin_type) {
          case 'online_user':
            break
          case 'sales_counter':
            if (tmp_plugin['cal_type'] === '+') {
              tmp_plugin['step'] = tmp_plugin['multiple']
            } else {
              tmp_plugin['step'] = tmp_plugin['multiple'] * -1
            }

            break
          default:
        }
      })

      console.log('handleRequestData:', tmp_plugins)
      return tmp_plugins
    },
    getMD5Hash(data_array) {
      const hash = new SparkMD5()
      for (let i = 0; i < data_array.length; i++) {
        const item = data_array[i]
        hash.append(`${i}-${item.value}`)
      }
      return hash.end()
    },
    handleLeave(event) {
      event.preventDefault() // 一些瀏覽器需要這行才能觸發
      event.returnValue = '' // 設定空字串來顯示預設警告訊息
      return false
    },
  },
}
</script>

<style scoped>
::v-deep .v-application--wrap {
  min-height: fit-content;
}
.v-application p {
  margin-bottom: 0px;
}
.optimize99-ab-test-header-container {
  background-color: #363e4d !important;
  /* height: 64px; */
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  /* position: fixed; */
  font-size: 20px;
  /* min-height: 64px; */
  /* z-index: 2; */
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
}
.optimize99-ab-test-header {
  background-color: #363e4d !important;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  font-size: 20px;
  min-height: 64px;
  width: 100%;
  color: #fff;
  display: flex;
  flex-direction: row;
}
.optimize99-ab-test-header > * {
  display: flex;
}
.optimize99-ab-test-header > .title > .back {
  align-items: center;
  border-right: 1px #7e8696 solid;
  height: 100%;
}
.optimize99-ab-test-header > .content {
  justify-content: center;
  align-items: center;
  flex: 1;
  background-color: #363e4d !important;
}
.optimize99-ab-test-header > .action {
  display: flex;
  align-items: center;
}
.opt-icon-container {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 100%;
  padding-right: 8px;
  padding-left: 8px;
}
.optimize99-ab-test-header > .title {
  align-items: center !important;
}

.optimize99-ab-test-header > .title > .logo {
  display: flex;
  align-items: center;
}

.optimize99-ab-test-header > .title > .logo > img {
  width: 34px;
}
.optimize99-ab-test-header > .title > .experience {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.opt-experience-name {
  font-size: 12px;
  line-height: 1.1;
  color: rgba(255, 255, 255, 0.7);
  overflow: hidden;
  white-space: nowrap;
  width: 8em;
  max-width: 10em;
  text-overflow: ellipsis;
}
.opt-version-name {
  font-size: 20px;
  color: rgba(255, 255, 255);
  line-height: 1.3;
  overflow: hidden;
  white-space: nowrap;
  width: 8em;
  max-width: 10em;
  text-overflow: ellipsis;
}
.device_selector {
  max-width: 200px;
}
.opt-save-btn {
  font-size: 14px !important;
  height: 100% !important;
  border-radius: 0px !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn_action_bg_linear {
  background: rgba(32, 166, 242, 0.9);
}
.btn-hightlight {
  background: linear-gradient(180deg, #f29b20, #f29b20) !important;
}
.btn_action {
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  height: 30px;
  cursor: pointer;
  padding: 0 30px;
  border-radius: 4px;
  color: #fff !important;
}
.reset-bd {
  border: 0 !important;
}
</style>
